import { Flame } from 'lucide-react';

const PRIORITIES = ['P1', 'P2', 'P3', 'P4'];
const CATEGORIES = ['Infrastructure', 'Application', 'Network', 'Database', 'Security', 'Cloud'];

const getCellColor = (count) => {
  if (count === 0) return 'bg-transparent';
  if (count <= 2) return 'bg-[#1a3a5c]';
  if (count <= 5) return 'bg-[#5c3a0a]';
  if (count <= 8) return 'bg-[#7c4a0a]';
  return 'bg-[#7c1a1a]';
};

const getCellTextColor = (count) => {
  if (count === 0) return 'text-[var(--nexus-text-muted)]';
  return 'text-white font-bold';
};

export const IncidentHeatMap = ({ data }) => {
  // Build a lookup
  const lookup = {};
  data.forEach(item => {
    const key = `${item.priority}-${item.category}`;
    lookup[key] = item.count;
  });

  return (
    <div data-testid="incident-heatmap" className="nexus-card relative overflow-hidden">
      <div className="p-3 border-b border-[var(--nexus-border)]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Flame size={14} className="text-[var(--nexus-danger)]" />
            <h2 className="text-sm font-semibold text-[var(--nexus-text-primary)] tracking-wide">Active Incidents Heat Map</h2>
          </div>
          <span className="text-[10px] text-[var(--nexus-text-muted)]">Priority x Category</span>
        </div>
      </div>
      <div className="p-3 overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr>
              <th className="text-[10px] uppercase tracking-wider text-[var(--nexus-text-muted)] text-left pb-2 pr-2 font-medium"></th>
              {CATEGORIES.map(cat => (
                <th key={cat} className="text-[10px] uppercase tracking-wider text-[var(--nexus-text-muted)] text-center pb-2 px-1 font-medium">
                  {cat.slice(0, 5)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {PRIORITIES.map(priority => (
              <tr key={priority}>
                <td className="font-mono text-[10px] text-[var(--nexus-text-secondary)] pr-2 py-1 font-semibold">{priority}</td>
                {CATEGORIES.map(cat => {
                  const count = lookup[`${priority}-${cat}`] || 0;
                  return (
                    <td key={cat} className="text-center px-1 py-1">
                      <div className={`w-full h-7 rounded flex items-center justify-center ${getCellColor(count)}`}>
                        <span className={`font-mono text-[10px] tabular-nums font-semibold ${getCellTextColor(count)}`}>
                          {count || '-'}
                        </span>
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
